const initOffuscation = (container = document) => {
  const links = container.querySelectorAll('[data-redirect-go]');
  if(links){
    links.forEach((link) => {
      const url = decodeURIComponent(window.atob(link.dataset.redirectGo));

      // Left mouse button
      link.addEventListener('click', (e) => {
        if (
            (e && (e.which == 2 || e.button == 4 )) 
            || e.ctrlKey 
            || (link.hasAttribute('target') && link.getAttribute('target') === '_blank')
          ) {
          window.open(url);
        } 
        else {
          window.location.href = url;
        }
      });
      
      // Middle mouse button
      link.addEventListener('mousedown', event => {
        // Remove scroll on middle click
        if (event.button === 1) event.preventDefault();
      });

      // Middle mouse button
      link.addEventListener('mouseup', event => {
        // Open link in new tab on middle click
        if (event.button === 1) window.open(url);
      });
    });
  }
}

export { initOffuscation }
